import React from 'react';
import SaloniLogoMark from './SaloniLogoMark';
import { BRAND_COPY_DEFAULTS } from '../content/pageCopyDefaults';

const DEFAULT_LOGO_PATHS = new Set([
  '/saloni-logo.png',
  '/saloni-logo.svg',
  '/saloni-logo-new.png',
  BRAND_COPY_DEFAULTS.logo_url,
]);

function isDefaultBrandLogo(src) {
  const path = String(src || '')
    .trim()
    .split('?')[0]
    .toLowerCase();
  if (!path) return true;
  return [...DEFAULT_LOGO_PATHS].some((p) => path === p.toLowerCase() || path.endsWith(p.toLowerCase()));
}

/**
 * Site brand logo — inline SVG mark for defaults, uploaded image otherwise.
 */
export default function BrandLogo({
  src,
  alt = 'Saloni Designs',
  className = '',
  size,
  width,
  height,
  'aria-hidden': ariaHidden,
  ...imgProps
}) {
  const w = width ?? size ?? 160;
  const h = height ?? size ?? 160;

  if (isDefaultBrandLogo(src)) {
    return (
      <SaloniLogoMark
        className={className}
        size={Math.max(w, h)}
        title={ariaHidden ? undefined : alt}
        aria-hidden={ariaHidden}
      />
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      width={w}
      height={h}
      loading="lazy"
      decoding="async"
      {...imgProps}
    />
  );
}
